import React, { useState, useEffect } from 'react';
import { Pagination } from '@mui/material';
import { useQuestionBank } from '../../pages/questionBank/hooks';

export const QuestionPagination = ({ filterDetails }) => {
    const { loadQuestions, loadCourseQuestions, pagination } = useQuestionBank();
    const { pageNumber: pageNo, pageSize, totalPages } = pagination;

    const [page, setPage] = useState(1);

    const handlePageChange = (event, value) => {
        if (filterDetails?.chapterId && filterDetails?.sectionId) {
            loadCourseQuestions({ courseId: filterDetails?.courseId, sectionId: filterDetails?.sectionId, chapterId: filterDetails?.chapterId, pageNo: value - 1, })
        } else if (filterDetails?.courseId && filterDetails?.sectionId) {
            loadCourseQuestions({ courseId: filterDetails?.courseId, sectionId: filterDetails?.sectionId, pageNo: value - 1, })
        } else if (filterDetails?.courseId) {
            loadCourseQuestions({ courseId: filterDetails?.courseId, pageNo: value - 1, })
        } else {
            loadQuestions({
                pageNo: value - 1, // backend pagination is 0-based
            });
        }
        // setPage(value);
        // onPageChange(value);
    };

    useEffect(() => {
        if (!pageNo) return setPage(1);
        setPage(pageNo + 1);
    }, [pageNo])
    return (
        <div style={styles.paginationContainer}>
            <Pagination
                count={(totalPages || 1)}
                page={page}
                onChange={handlePageChange}
                color="primary"
            />
        </div>
    );
};


const styles = {
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '3rem'
    }
}